import React from "react";
import { imgUrl } from "../config/api";

export default function SwatchesComponent({
  swatches,
  pageLanguage,
  NumberToPersianWord,
  GetPrice,
  t,
  isTabletOrMobile,
}) {
  return (
    <div>
      {swatches
        .slice()
        .sort((a, b) => a.PayableAmount - b.PayableAmount).reverse()
        .map((obj, i) => {
          
          let ProductDesignEnName = obj["DesignEnName"];
          let ProductDesignName = obj["DesignName"];
          let ProductColorEnName = obj["ColorEnName"];
          let ProductColorName = obj["ColorName"];
          let photoUrl = obj["PhotoUrl"];
          let price = obj["PayableAmount"];
          let count = obj["Count"];

          return (
            <li className="checkout_item_container" key={i}>
              <div className="checkout_item_image_container">
                <img
                  src={imgUrl(photoUrl)}
                  alt=""
                  className="checkout_item_img"
                />
                <p className="checkout_item_image_qty">
                  {pageLanguage === "fa" ? NumberToPersianWord.convertEnToPe(`${count}`) : count}
                </p>
              </div>
              <div className="checkout_item_desc_container">
                <div className="checkout_item 4">
                  <h1 className="checkout_item_name">{t("Fabric Swatch")}</h1>
                  <span className="checkout_item_price">
                    {price === 0
                      ? t("Free")
                      : GetPrice(price * count, pageLanguage, t("TOMANS"), isTabletOrMobile)}
                  </span>
                </div>
                <h2 className="checkout_item_details checkout_item_details_design">
                  {pageLanguage === "fa" ? ProductDesignName : ProductDesignEnName}
                </h2>
                <span className="checkout_item_discount  checkout_item_details_color">
                  {pageLanguage === "fa" ? ProductColorName : ProductColorEnName}
                </span>
              </div>
            </li>
          );
        })}
    </div>
  );
}
